import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorCreateBot = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M12.75 4.291a1.636 1.636 0 1 0-1.5 0v4.073h1.5V4.29Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M2.25 10.3A2.75 2.75 0 0 1 5 7.55h14a2.75 2.75 0 0 1 2.75 2.75v4.5a.75.75 0 1 1-1.5 0v-4.5c0-.69-.56-1.25-1.25-1.25H5c-.69 0-1.25.56-1.25 1.25v9c0 .69.56 1.25 1.25 1.25h7a.75.75 0 0 1 0 1.5H5a2.75 2.75 0 0 1-2.75-2.75v-9Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M18 15.05a.75.75 0 0 1 .75.75v6a.75.75 0 1 1-1.5 0v-6a.75.75 0 0 1 .75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M14.25 18.8a.75.75 0 0 1 .75-.75h6a.75.75 0 0 1 0 1.5h-6a.75.75 0 0 1-.75-.75Z"
      clipRule="evenodd"
    />
    <path
      fill="#F7A600"
      d="M16 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM10 13a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    />
  </svg>
);
export default SvgTwoColorCreateBot;
